module.exports = __webpack_public_path__ + "static/media/auto (1).8c010787.png";